import React, { type ReactNode } from 'react';

import { ItemsListBuilder, type ItemsListBuilderProps } from '@atlassian/company-hub-common';
import { useInitialUnsplashResults } from '@atlassian/company-hub-common/media-components';

import { CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE } from '../../../../constants';
import type { Card } from '../../../../types';
import { CardContent, type CardContentProps } from './card-content';

type CardsAreaProps = Omit<
	CardContentProps,
	'cardParameters' | 'initialUnsplashResults' | 'isCardDisabled' | 'analyticsSource'
> &
	Omit<ItemsListBuilderProps, 'actionSubjectIdPostFix' | 'analyticsSource' | 'renderItemContent'>;

const actionSubjectIdPostFix = 'Card';

export const CardsArea = ({ ...cardsAreaContainerProps }: CardsAreaProps): React.JSX.Element => {
	const {
		items,
		contentId,
		isNoImageAllowed,
		showBgAndTextColorOptions,
		showDescription,
		layout,
		size,
		showMediaPicker,
		showSegmentation,
		showLabel,
		updateCardFormField,
	} = cardsAreaContainerProps;

	const initialUnsplashResults = useInitialUnsplashResults(items);

	const renderCardContent = (cardParameters: Card, isCardDisabled: boolean): ReactNode => (
		<CardContent
			cardParameters={cardParameters}
			contentId={contentId}
			initialUnsplashResults={initialUnsplashResults}
			isDisabled={isCardDisabled}
			isNoImageAllowed={isNoImageAllowed}
			showBgAndTextColorOptions={showBgAndTextColorOptions}
			showDescription={showDescription}
			layout={layout}
			size={size}
			showMediaPicker={showMediaPicker}
			showSegmentation={showSegmentation}
			showLabel={showLabel}
			updateCardFormField={updateCardFormField}
		/>
	);

	return (
		<ItemsListBuilder
			analyticsSource={CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE}
			actionSubjectIdPostFix={actionSubjectIdPostFix}
			renderItemContent={renderCardContent}
			{...cardsAreaContainerProps}
		/>
	);
};
